<div class="student-programs">
    <div class="k-d-flex k-justify-content-between title" *ngIf="!isDashboardIep">
        <h4 class="subsection__heading k-p-4 !k-mt-0 k-w-full">{{title}}</h4>

        <button kendoButton #anchor [svgIcon]="moreVerticalIcon" [fillMode]="'flat'" fillMode="clear" title="Actions"
            *ngIf="allowCaptureFAD()"></button>
        <kendo-contextmenu [target]="anchor" showOn="click">
            <ng-template kendoContextMenuTemplate>
                <app-custom-actions [studentDetails]="studentProfile" [actionsList]="actionsList"
                    (rfdDialog)="displayRfdDialog($event)"
                    (captureFirstAttendDate)="displayFAD($event)"></app-custom-actions>
            </ng-template>
        </kendo-contextmenu>

    </div>

    <div class="dashboard-iep k-mx-4" *ngIf="isDashboardIep">
        <p class="!k-font-semibold !k-m-0">{{title}} ({{programs?.length}})</p>
    </div>

    <div class="k-p-4" [ngClass]="{'body': !isTwelveMonthDialog}">
        <ng-container *ngIf="programs?.length">
            <ng-container *ngFor="let program of programs;  let i = index;">
                <div class="program-name justify k-hstack">
                    <div>
                        <div style="
                    display: flex;
                ">
                            <h5 class="subsection__subheading">{{program?.mandateDescription}}</h5>
                            <kendo-chip size="large" rounded="small" fillMode="solid" themeColor="success"
                                [removable]="false" class="kendo-chip k-ml-2" label="12 months"
                                *ngIf="program?.isTwelveMonth"> </kendo-chip>

                        </div>
                    </div>
                </div>

                <div class="program-details k-mt-4 k-hstack gap-48">
                    <div class="k-hstack" *ngIf="program?.language">
                        <span
                            [ngClass]="{ 'label-border': program?.frequency || program?.duration}">{{program?.language}}
                        </span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.frequency">
                        <span
                            [ngClass]="{ 'label-border': program?.duration || program?.ratio  }">{{program?.frequency}}
                        </span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.duration">
                        <span [ngClass]="{ 'label-border':  program?.ratio  }">{{program?.duration}}</span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.ratio">
                        <span [ngClass]="{ 'label-border': program?.groupType}"><span *ngIf="program?.ratio"> Student
                                to Teacher Ratio:</span> {{program?.ratio}} </span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.groupType">
                        <span class="margin">| Group Type: {{program?.groupType}} </span>
                    </div>
                    <div class="k-hstack" *ngIf="shouldShowGroupSize(program)">
                        <span class="margin">| Group Size: {{program?.groupSize}} </span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.serviceType">
                        <span class="margin"> | Service Type: {{program?.serviceType}} </span>
                    </div>
                    <div class="k-hstack" *ngIf="program?.serviceDeliveryrec">
                        <span class="margin"> | Service Delivery Recommendation: {{program?.serviceDeliveryrec}} </span>
                    </div>
                </div>
                <div class="program-details k-mt-4 k-hstack gap-48">
                    <div class="k-hstack">
                        <fa-icon icon="calendar" class="icon k-mr-2"></fa-icon>
                        <span class="label"> {{program?.serviceStartDate | formatDate}} &nbsp; -
                            &nbsp;{{program?.serviceEndDate | formatDate}}</span>
                    </div>

                </div>
                <div class="program-details k-mt-4 k-hstack gap-48" *ngIf="program?.location || program?.locationOther">
                    <div class="k-hstack">
                        <fa-icon icon="location-dot" class="icon k-mr-2"></fa-icon>
                        <span class="label k-mr-2" *ngIf="program?.location"> {{program?.location}}</span>
                        <span class="label" *ngIf="program?.locationOther">{{program?.locationOther}}</span>
                    </div>

                </div>
                <div class="program-details k-mt-4 k-hstack gap-48"
                    *ngIf="studentIEP?.seitAgency && program?.mandateType === 'SEIT'">
                    <div class="k-hstack">
                        <fa-icon icon="tree-city" class="icon k-mr-2"></fa-icon>
                        <span class="label"> {{studentIEP?.seitAgency}}</span>
                    </div>

                </div>
                <span class="k-form-separator !k-my-4" *ngIf="programs?.length - 1 !== i"></span>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!programs?.length">
            <p>No {{title}} to show</p>
        </ng-container>
    </div>

</div>

<kendo-dialog *ngIf="showRfdDialog$ | async" [title]="canEdit ? 'Add Reason for Delay' : 'View Reason for Delay'"
    (close)="rfd.onCloseClick()" [width]="786" [height]="'90vh'" [minWidth]="'1166'" (click)="$event.stopPropagation()">
    <app-reason-for-delay #rfd (close)="displayRfdDialog($event)" (saveEmitter)="onRfdSaved()"
        [studentDetails]="studentProfile" [referralsk]="studentProfile?.referralSK"
        [studentSk]="studentProfile?.studentSk" [nycId]="studentProfile?.nycId" [eiId]="studentProfile?.eiId"
        [isPreSchool]="studentProfile?.isPreSchool" [canEdit]="canEdit">
    </app-reason-for-delay>
    <kendo-dialog-actions>
        <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" *ngIf="canEdit"
            [disabled]="!rfd.hasActiveReasons || rfd.loadSpinner" (click)="rfd.save()">Save</button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-capture-first-attend-date-dialog [nycId]="studentIEP?.nycid" [studentIEP]="studentIEP"
    *ngIf="showCaptureFirstAttendDate$ | async" (close)="closeCaptureFirstAttendDateDialog()" (saved)="onFADSaved()">
</app-capture-first-attend-date-dialog>